import {Injectable} from "@angular/core";
import {FormFieldConfig} from "../../../model/api/form-field-config";
import {FormFieldGroupConfig} from "../../../model/api/form-field-group-config";
import {
  BatchActionSupportClearingFormComponent
} from "../../../crystal-clear/support/clearing-crud/batch-update-form/batch-action-support-clearing-form.component";
import {Account} from "../../../model/clearing/account";
import {TableColumnConfig} from "../../../model/api/table-column-config";
import {TableColumnUtils} from "../../../utils/table-column-utils";
import {BatchFormUtils} from "../../../utils/batch-form-utils";
import {Clearing} from "../../../model/clearing/clearing";
import {SupportClearingFormConfigService} from "./support-clearing-form-config.service";
import TYPE = FormFieldConfig.TYPE;

@Injectable({
  providedIn: 'root'
})
export class SupportClearingBatchFormConfigService {

  /** fields selected for update */
  fieldsToUpdate: string[] = [];

  private readonly excludedFields = [
    'id',
    'account',
    'clearings',
    'clearingInfo',
    'trade',
    'order'
  ];

  loadConfig(
    component: BatchActionSupportClearingFormComponent
  ): FormFieldGroupConfig[] {

    const tradeFields: FormFieldConfig[] =
      (Object.keys(new Clearing()) as Array<keyof Clearing>)
        .filter(f => BatchFormUtils.isEditable(f as string, this.excludedFields))
        .map(f =>
          BatchFormUtils.buildBatchField<Clearing>(
            f,
            SupportClearingFormConfigService.fieldTypes[f],
            this.fieldsToUpdate,
            component.ccFormDialog
          )
        );

    tradeFields.forEach(
      f => f.options = SupportClearingFormConfigService.buildOptions(f, component.dataLoadingService)
    );

    const accountFields: FormFieldConfig[] =
      (Object.keys(new Account()) as Array<keyof Account>)
        .filter(f => BatchFormUtils.isEditable(f as string, this.excludedFields))
        .map(f =>
          BatchFormUtils.buildBatchField<Account>(
            f,
            SupportClearingFormConfigService.fieldTypes[f],
            this.fieldsToUpdate,
            component.ccFormDialog,
            'account.'
          )
        );

    const accountColumns: TableColumnConfig[] =
      (Object.keys(new Account()) as Array<keyof Account>)
        .map(f =>
          TableColumnUtils.buildColumn<Account>(
            f,
            SupportClearingFormConfigService.fieldTypes[f]
          )
        );

    return [
      {
        group: 'account',
        fields: [
          {
            field: 'account',
            column: 12,
            type: TYPE.SINGLERICHFIELD,
            richFieldConfig: {
              fieldId: 'name',
              fieldName: 'name',
              tableConfigs: accountColumns,
              fields: [{ group: '', fields: accountFields }]
            }
          }
        ]
      },
      {
        group: 'fields',
        fields: tradeFields
      }
    ];
  }

}
